<div class="overflow-auto h-100" *ngIf="displayResults">
  <ns-grid
    name="RATE"
    [columns]="columnDefs"
    [data]="data"
    [loading]="loading"
    [resizeType]="resizeType"
    [gridOptions]="options"
    [config]="config"
    (dataRendered)="gridDataRendered($event)">
  </ns-grid>
</div>
